export default "skymp5-front/1d6aac3d1a2bb23d7defe044d91f6f8e.gif";